import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'motion/react';
export const Fade = ({ children, duration, className }) => {
    return (_jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: duration }, className: className, children: children }));
};
export * from './animate-height';
//# sourceMappingURL=index.js.map